<div class="ui grid">
  <div class="row">
    <div class="sixteen wide column">
      <h1 class="ui header">Nutzer bearbeiten:</h1>
    </div>
  </div>
  @if (user) {
    <div class="row">
      <div class="sixteen wide column">
        <sui-tabset>
          <div class="ui top attached tabular menu">
            <a class="item" suiTabHeader="1">Profil</a>
            <a class="item" suiTabHeader="2">Newsletter</a>
          </div>
          <div class="ui bottom attached segment" suiTabContent="1">
            <app-user-profile-form
              #userForm
              [editUser]="user"
              [admin]="true"
              (institutionChanged)="userNewsletterForm.setEmailValidators($event)"
            ></app-user-profile-form>
          </div>
          <div class="ui bottom attached segment" suiTabContent="2">
            <app-user-newsletter-form
              #userNewsletterForm
              [editUser]="user"
              [admin]="true"
            ></app-user-newsletter-form>
            Letzte Email gesendet am: {{ user?.abonnement?.lastMailSend | date: 'dd.MM.yyyy HH:mm' }}
          </div>
        </sui-tabset>
      </div>
    </div>
    <div class="row">
      <div class="sixteen wide column">
        <button
          class="ui primary button"
          (click)="save(userForm.submit(), userNewsletterForm.submit())"
          [disabled]="userForm.userForm.invalid || userNewsletterForm.newsletterForm.invalid"
        >
          Speichern
        </button>
      </div>
    </div>
  }
</div>
